
export const ACCOUNT_API_URL = {
    login: '/oauth/token',
    employerSignup: '/employer/create',
    emailPhoneValidate:'/employer/email-phone-validate',
    companyLogo: '/employer/update-photo-logo',
    govtDoc: "/employer/update-photo-govt",
    postJob: '/job-post/create',
    listJob: '/job-post/list',
    jobApplicationList: '/job-applications/application-list',
    listJobFilter: '/job-post/filter',
    viewJob: '/job-post/view',
    statusJob: '/job-post/status',
    statusCertificate: '/certification-courses/status',
    UpdateJob: '/job-post/update',
    employerInvoice: '/job-post/invoice',
    deleteJob: '/job-post/delete',
    employerProfile: '/employer/profile',
    updateUserProfile: 'employer/update',
    JobCategoryList: '/job-category/list',
    JobCertificationList: '/job-certification/list',
    JobQualificationsList: '/qualifications/list',
    JobSkillList: '/skills/list',
    CreateNewSkills: '/skills/create',
    CreateNewCertification: '/job-certification/create',
    CreateNewQualification: '/qualifications/create',
    enableSubscription:'/employer-subscription/enable',
    sendOtp: '/employee/otp-send',
    sendMobileOtp: '/employee/verify-mobile',
    verifyOtp: '/employee/otp-verify',
    employeeSignup: '/employee/create',

    employeeProfile: 'employee/profile',
    employeeProfileUpdate: '/employee/update',
    employeeBankUpdate: '/employee/update-bank-details',
    employeePhotoUpdate: '/employee/update-photo-profile',
    employeeResumeUpdate: '/employee/resume-upload',
    employeeDetails:'/job-applications/excel-list',
    jobApplicationView: '/job-applications/application-view',
    jobApplicationDetails: '/job-applications/view',
    jobApplyStatus: '/job-applications/application-status',
    distributeCertificate: '/certification-courses-application/certificate-distribution',
    employeeSubscriptionPayment: '/employee-subscription/payment',

    employePayment: '/employee-subscription/payment',
    employeeTabData: '/job-applications/list',
    employeeTabPrivateJob: '/job-post/private-job-list',
    jobPostPayementSubmit: '/job-post/payment',
    certificatePayementSubmit:'/certification-courses/payment-verify',
    employerSubscription: '/employer-subscription/create',
    employerSubscriptionVerify: '/employer-subscription/retrieve',
    employerSubscriptionView: '/employer-subscription/view',
    employeeSubscription: '/employee-subscription/create',
    employeeSubscriptionVerify: '/employee-subscription/retrieve',
    employeeSubscriptionView: '/employee-subscription/view',
    getEmployeeBankDetails: 'employee/get-bank-details',
    jobApplicationCreate: '/job-applications/create',
    employeeRenewal: "/employee-subscription/renewal",
    employerRenewal: "/employer-subscription/renewal",
    sendOtpEmployer: '/employer/otp-send',
    verifyOtpEmployer: '/employer/otp-verify',
    applicationAccept: "/job-applications/application-accept",
    applicationPayment: "/job-applications/application-payment",
    requestPassword: "/request-password",
    setPassword: "/account/reset-password",
    createPassword: "/employee/set-password",
    sendEmailOtp: "/employee/email-otp-send",
    verifyEmailOtp: "/employee/email-otp-verify",
    govDocDelete: "/employer/delete-gov-doc",
    employerTag: "/job-applications/employer-tag",
    employeeTag: "/job-applications/employee-tag",
    notificationsList: "/notifications/list",
    employerNotificationsList: "/notifications/employer-list",
    jobApplicationAcceptRejectParttime: "/job-applications/application-accept-parttimer",
    employeeProfileGet: '/employee/profile',
    rejectionPayment: '/employee/rejection-payment',
    rejectionPaymentCapture: 'employee/rejection-payment-capture',
    certificationCourseList: '/certification-courses/list',
    certificationCourseApplicationList: '/certification-courses-application/application-list',
    certificateCreate: "/certification-courses/create",
    UpdateCertificate: "/certification-courses/update",
    viewCertification: "/certification-courses/view",
    certificationFilter: "/certification-courses/filter",
    certificateAppliedView: "/certification-courses-application/applied-candidate",
    employerComplaint: "/employer-complaint/create",
    employeeComplaint: "/employee-complaint/create",
    certificationApplicationCreate: "/certification-courses-application/create",
    isReadedApi: '/notifications/is-readed',
    userReviewList: "/review/user-review",
    userReviewCreate: "/review/create",

    employerSubscriptionTrail: '/employer-subscription/trail',
    employeeSubscriptionTrail: '/employee-subscription/trail',
    employeeProfileView: '/employee/view',
    employeeUserView: '/employee/view-employee',
    rating: '/review/user-review',
    recentWork: '/job-post/recent-parttimer-job',
    recentJobPost: '/job-post/recent-employer-job',
    employerView: '/employer/view',
    employerSubscriptioData:'employer-subscription/subscription-data',
    certificatePhotosUpdate: '/certification-courses/certificate-logo',
    EmployeeList: '/employee/list',
    GroupsList:'/groups/list',
    GroupsCreate:'/groups/create',
    GroupsUpdate:'/groups/update',
    GroupsView:'/groups/view',
    employeeDeleteAccount:'/employee/delete-account',
    employerDeleteAccount:'/employer/delete-account',
    
    certificateStatus : '/certification-courses/applied',
    employeeDetailsDownload:'/certification-courses-application/excel-list',
    removePhoto:'/employer/profile-delete',
    updateEmployerJobIncomplete:'/job-post/job-incomplete',
    updateParttimerJobIncomplete:'/job-applications/job-incomplete',
    ProfileImg:'/employer/organizer-photo-upload'

}
